import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { Button, Container, Form, Input } from "reactstrap";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { Box, TextField } from "@mui/material";
import ImageUploader from "../../common/ImageUploader";
import TextEdior from "../../common/TextEdior";
// import AddBannerInner from "./AddBannerInner";

function Modal({
  isModalShow,
  onClose,
  handleFileSelect,
  fieldData,
  setFieldData,
  handleSubmit,
  previewUrl,
  videoUrl,
  handleUrlChange,
  videoId,
}) {
  return (
    <Transition.Root show={isModalShow} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[9999]"
        // initialFocus={cancelButtonRef}
        onClose={() => {}}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <Container
          className="fixed inset-0 z-10 overflow-y-auto mt-10"
          // onClick={onClose}
        >
          <div className="flex items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-3xl">
                <Container className="flex justify-between items-center">
                  <p className="ml-5 text-lg font-semibold">
                    {fieldData.update ? "Update" : "Add"} Insight
                  </p>
                  <Dialog.Title
                    as="button"
                    onClick={onClose}
                    className="text-lg font-medium leading-6 text-gray-900 text-right p-5 outline-none"
                  >
                    <AiOutlineCloseCircle />
                  </Dialog.Title>
                </Container>
                {/* <AddBannerInner
                  onClose={onClose}
                  //   fetchBannerData={fetchBannerData}
                /> */}

                <Form onSubmit={handleSubmit}>
                  <Box
                    sx={{
                      maxWidth: "100%",
                    }}
                    className="mx-8"
                  >
                    <TextField
                      fullWidth
                      name="insight_name"
                      label="Insight Name"
                      id="fullWidth"
                      sx={{
                        "& .MuiInputLabel-root": {
                          fontFamily: "Poppins",
                        },
                        "& .MuiInputLabel-root": {
                          fontFamily: "Poppins",
                        },
                        "& .MuiOutlinedInput-root": {
                          fontFamily: "Poppins",
                          borderRadius: "12px",
                        },
                        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                          {
                            borderColor: "#800000",
                          },
                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                          {
                            borderColor: "#800000",
                          },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #800000",
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#800000",
                        },
                        marginBottom: "20px",
                      }}
                      //   onChange={props.handleChange}
                      onChange={(e) =>
                        setFieldData({ ...fieldData, title: e.target.value })
                      }
                      value={fieldData.title}
                      required
                    />

                    <TextEdior
                      className="mb-5"
                      placeholder="Insight Description..."
                      handleChange={(e) => {
                        setFieldData({ ...fieldData, description: e });
                      }}
                      value={fieldData.description}
                    />

                    <Container className="mb-5">
                      <Input
                        type="file"
                        accept="image/png, image/jpeg, image/jpg"
                        onChange={handleFileSelect}
                      />
                      {previewUrl && (
                        <div
                          className="mt-4 overflow-hidden rounded-lg border border-[#ddd]"
                          style={{
                            width: 150,
                            height: 120,
                          }}
                        >
                          <img
                            src={previewUrl}
                            alt="Preview"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      )}
                    </Container>

                    <Container className="mb-5">
                      <TextField
                        type="url"
                        placeholder="https://www.youtube.com/watch?v=..."
                        fullWidth
                        name="yt_video"
                        label="Youtube Video Url"
                        id="fullWidth"
                        sx={{
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins",
                          },
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins",
                          },
                          "& .MuiOutlinedInput-root": {
                            fontFamily: "Poppins",
                            borderRadius: "12px",
                          },
                          "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor: "#800000",
                            },
                          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor: "#800000",
                            },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid #800000",
                          },
                          "& .MuiInputLabel-root.Mui-focused": {
                            color: "#800000",
                          },
                          // marginBottom: "20px",
                        }}
                        value={
                          videoUrl == null || videoUrl == "null" ? "" : videoUrl
                        }
                        onChange={handleUrlChange}
                      />
                      <p className="mt-2 text-xs text-gray-500">
                        Supports: youtube.com/watch?v=..., youtu.be/...,
                        youtube.com/embed/...
                      </p>

                      {/* Preview Section */}
                      {videoId && (
                        <Container className="mt-5 p-4 bg-gray-50 rounded-lg border border-gray-200">
                          <h3 className="text-lg font-medium text-gray-800 mb-3">
                            Preview
                          </h3>

                          <div className="space-y-4">
                            {/* Embed Preview */}
                            <div className="mt-4">
                              <h4 className="text-sm font-medium text-gray-700 mb-2">
                                Embed Preview:
                              </h4>
                              <div className="aspect-w-16 aspect-h-9">
                                <iframe
                                  src={`https://www.youtube.com/embed/${videoId}`}
                                  title="YouTube video player"
                                  frameBorder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                  allowFullScreen
                                  className="w-full min-h-[350px] rounded-lg"
                                />
                              </div>
                            </div>

                            {/* Video Details */}
                            <div className="mt-4 p-3 bg-white rounded-md border border-gray-200">
                              <p className="text-sm text-gray-600">
                                <span className="font-medium">Video ID:</span>{" "}
                                <code className="px-2 py-1 bg-gray-100 rounded text-xs font-mono">
                                  {videoId}
                                </code>
                              </p>
                              <p className="text-sm text-gray-600 mt-2">
                                <span className="font-medium">Embed URL:</span>{" "}
                                <code className="px-2 py-1 bg-gray-100 rounded text-xs font-mono break-all">
                                  https://www.youtube.com/embed/{videoId}
                                </code>
                              </p>
                            </div>
                          </div>
                        </Container>
                      )}
                    </Container>

                    <Container className="flex justify-end items-center mb-5">
                      <Button
                        type="submit"
                        className="px-8 py-2 bg-slate-800 text-white font-semibold rounded-lg active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out disabled:cursor-not-allowed disabled:bg-slate-500"
                        // disabled={
                        //   //   props.data.name.length < 1 ||
                        //   !selectedImages ? true : false
                        // }
                      >
                        {fieldData.update ? "Update" : "Save"}
                      </Button>
                    </Container>
                  </Box>
                </Form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Container>
      </Dialog>
    </Transition.Root>
  );
}

export default Modal;
